import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
    wrapper: {
        gap: 10,
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        '@media (max-width: 1375px)': {
            justifyContent: 'flex-start'
        }
    },
    block: {
        backgroundColor: 'white',
        width: 224,
        height: 160,
        padding: '16px 14px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        '@media (max-width: 1470px)': {
            width: 210
        }
    },
    title: {
        fontSize: 16,
        fontWeight: 500,
        color: theme.palette.grey[900]
    },
    valueBlock: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        height: 75
    },
    value: {
        fontSize: 28,
        fontWeight: 700,
        color: 'black'
    },
    valueBottom: {
        marginTop: 7,
        height: 20,
        fontSize: 11,
        '& img': {
            marginRight: 3,
            marginLeft: -8
        },
        '& span': {
            marginRight: 3
        }
    },
    baseButton: {
        color: theme.palette.blue[600],
        fontWeight: 600,
        fontSize: 16
    },
    green: {
        color: '#00B69B'
    },
    red: {
        color: '#F93C65'
    },
    constant: {
        color: theme.palette.grey[700]
    },
    constantBlock: {
        backgroundColor: theme.palette.grey[100]
    },
    noData: {
        fontSize: 14,
        fontWeight: 400,
        color: theme.palette.grey[800]
    }
}));

export default useStyles;
